/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { css } from 'styled-components';

const TaskLoaderStyles = css`
	.loader-wrapper {
		display: flex;
		align-items: center;
		flex-direction: column;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		.image {
			width: 44px;
			height: 44px;
		}

		.text {
			font-size: 1.5em;
			font-family: var(--font-regular);
			line-height: normal;
			margin: 0;
		}
	}
`;

export default TaskLoaderStyles;
